module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "top",
    staticClass: "sans-serif",
    class: {
      'in-process': _vm.currentStepIndex >= 0 && _vm.currentStepIndex < _vm.steps.length
    },
    attrs: {
      "id": "app"
    }
  }, [_c('header', [_c('div', {
    staticClass: "Topnav"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.currentStepIndex = 0
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/logo.png"),
      "width": "100%"
    }
  })])]), _vm._m(0), _c('div', {
    staticClass: "right-column"
  })])]), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.currentStepIndex < 0) ? _c('section', {
    key: "hero",
    staticClass: "Hero black-90 ph3 mh-5 tc flex flex-column justify-center"
  }, [_c('div', {
    staticClass: "Hero-Space"
  }, [_c('h1', {
    staticClass: "mb4 mr4 ml4"
  }, [_vm._v(_vm._s(_vm.settings.homeHeader))]), _vm._l((_vm.homeTextLines), function(homeText, idx) {
    return _c('p', {
      key: 'line' + idx,
      staticClass: "mr4 ml4"
    }, [_vm._v(_vm._s(homeText))])
  }), _c('div', {
    staticClass: "mt4 ml4 mr4"
  }, [_c('a', {
    staticClass: "BottomNavButton BottomNavButton--fluid",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.currentStepIndex = 0
      }
    }
  }, [_vm._v("Get started")])])], 2)]) : _vm._e(), (_vm.currentStepIndex === _vm.steps.length) ? _c('section', {
    key: "success",
    staticClass: "Hero black-90 ph3 mh-5 tc flex flex-column justify-center"
  }, [_c('div', {
    staticClass: "Hero-Space center"
  }, [_c('h1', {
    staticClass: "f2 fw2 mb1"
  }, [_vm._v(_vm._s(_vm.settings.submissionHeader))]), _c('h2', {
    staticClass: "f6 f5-l fw4",
    domProps: {
      "innerHTML": _vm._s(_vm.settings.submissionText)
    }
  }), _c('div', {
    staticClass: "mt5"
  }, [_c('a', {
    staticClass: "BottomNavButton BottomNavButton--fluid",
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Make another estimate")])])])]) : _vm._e(), (_vm.currentStepIndex >= 0 && _vm.currentStepIndex < _vm.steps.length) ? _c('section', {
    key: "process",
    staticClass: "Process"
  }, [_c('div', {
    ref: "steps-top",
    staticClass: "dn db-ns"
  }), _c('bookart-steps', {
    attrs: {
      "steps": _vm.steps,
      "disabled-options": _vm.disabledOptions
    },
    model: {
      value: (_vm.currentStepIndex),
      callback: function($$v) {
        _vm.currentStepIndex = $$v
      },
      expression: "currentStepIndex"
    }
  }), _c('section', {
    ref: "categories",
    staticClass: "Categories ph3 ph5-l mb6 black-90"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('div', {
    key: _vm.currentStepIndex
  }, [(_vm.currentStepIndex === 0) ? _c('bookart-quantities', {
    attrs: {
      "settings": _vm.settings
    },
    model: {
      value: (_vm.quantities),
      callback: function($$v) {
        _vm.quantities = $$v
      },
      expression: "quantities"
    }
  }) : _vm._e(), _vm._l((_vm.sections.general), function(catI) {
    return (_vm.currentStepIndex === 0) ? _c('bookart-category', {
      attrs: {
        "selected-option-index": _vm.selectedOptions[catI]
      },
      on: {
        "select": function($event) {
          return _vm.selectOption(catI, $event)
        }
      },
      model: {
        value: (_vm.categories[catI]),
        callback: function($$v) {
          _vm.$set(_vm.categories, catI, $$v)
        },
        expression: "categories[catI]"
      }
    }) : _vm._e()
  }), _vm._l((_vm.sections.cover), function(catI) {
    return (_vm.currentStepIndex === 1 && !_vm.isCategoryIndexDisabled[catI]) ? _c('bookart-category', {
      attrs: {
        "selected-option-index": _vm.selectedOptions[catI]
      },
      on: {
        "select": function($event) {
          return _vm.selectOption(catI, $event)
        }
      },
      model: {
        value: (_vm.categories[catI]),
        callback: function($$v) {
          _vm.$set(_vm.categories, catI, $$v)
        },
        expression: "categories[catI]"
      }
    }) : _vm._e()
  }), _vm._l((_vm.sections.paper), function(catI) {
    return (_vm.currentStepIndex === 2 && !_vm.isCategoryIndexDisabled[catI]) ? _c('bookart-category', {
      attrs: {
        "selected-option-index": _vm.selectedOptions[catI]
      },
      on: {
        "select": function($event) {
          return _vm.selectOption(catI, $event)
        }
      },
      model: {
        value: (_vm.categories[catI]),
        callback: function($$v) {
          _vm.$set(_vm.categories, catI, $$v)
        },
        expression: "categories[catI]"
      }
    }) : _vm._e()
  }), (_vm.currentStepIndex === 3) ? _c('bookart-review', {
    attrs: {
      "categories": _vm.categories,
      "discounts": _vm.discounts,
      "pageprices": _vm.pageprices,
      "disabled-options": _vm.disabledOptions,
      "quantities": _vm.quantities,
      "selected-options": _vm.selectedOptions,
      "groups": _vm.groups,
      "settings": _vm.settings
    }
  }) : _vm._e(), (_vm.currentStepIndex === 4) ? _c('bookart-submit', {
    ref: "submit",
    attrs: {
      "settings": _vm.settings
    },
    on: {
      "success": _vm.success
    },
    model: {
      value: (_vm.projectInfos),
      callback: function($$v) {
        _vm.projectInfos = $$v
      },
      expression: "projectInfos"
    }
  }) : _vm._e()], 2)]), _c('section', {
    staticClass: "BottomNav pa2-m pa4-l mb5 m dn db-ns tc"
  }, [(_vm.currentStepIndex > 0) ? _c('a', {
    staticClass: "BottomNavButton BottomNavButton--empty",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.currentStepIndex -= 1
      }
    }
  }, [_vm._v("Previous")]) : _vm._e(), (_vm.currentStepIndex < _vm.steps.length - 1) ? _c('a', {
    staticClass: "BottomNavButton",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.currentStepIndex += 1
      }
    }
  }, [_vm._v("Next")]) : _vm._e(), (_vm.currentStepIndex === _vm.steps.length - 1) ? _c('a', {
    staticClass: "BottomNavButton BottomNavButton--submit",
    class: {
      'disabled': _vm.quantities.books < 50
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submitForm.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")]) : _vm._e()])], 1), (_vm.quantities.books > 0) ? _c('bookart-summary', {
    attrs: {
      "categories": _vm.categories,
      "disabled-options": _vm.disabledOptions,
      "discounts": _vm.discounts,
      "pageprices": _vm.pageprices,
      "quantities": _vm.quantities,
      "selected-options": _vm.selectedOptions,
      "groups": _vm.groups,
      "settings": _vm.settings
    }
  }) : _vm._e()], 1) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner"
  }, [_c('nav', [_c('div', {
    staticClass: "nav-inner"
  }, [_c('div', {
    staticClass: "TopnavEl dn db-ns"
  }, [_c('a', {
    attrs: {
      "href": "http://www.bookart.ca/create-book/"
    }
  }, [_vm._v("Create Book")])]), _c('div', {
    staticClass: "TopnavEl dn db-ns"
  }, [_c('a', {
    attrs: {
      "href": "http://www.bookart.ca/library/"
    }
  }, [_vm._v("Library")])]), _c('div', {
    staticClass: "TopnavEl dn db-ns"
  }, [_c('a', {
    attrs: {
      "href": "http://www.bookart.ca/about/"
    }
  }, [_vm._v("About")])]), _c('div', {
    staticClass: "TopnavEl dn db-ns"
  }, [_c('a', {
    attrs: {
      "href": "http://www.bookart.ca/shop/"
    }
  }, [_vm._v("Shop")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-59c95520!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 190
// module chunks = 2